/**
 * The zones module's paths — spec §8.10.
 *
 * `/zones` is what `layout/nav-items.ts` already points its `geofences` entry at, so
 * the prefix is not a choice this phase gets to make; the sub-routes hang off it.
 *
 * Route paths stay in English while the UI defaults to French — the address bar is
 * not a translated surface, and a localized URL set would mean two routing tables and
 * a redirect on every language switch.
 *
 * Registration lives in `routes/app-routes.tsx`, which this phase does not own.
 * NOTES-PHASE7-WEB.md §1 carries the patch, and it MUST lazy-load this module's
 * barrel: every screen here loads MapLibre, and a static import would put ~1.45 MB of
 * WebGL renderer back into the entry chunk that the map and trips splits exist to
 * keep it out of.
 */

export const ZONES_PATH = '/zones'
export const ZONE_NEW_PATH = '/zones/new'
export const ZONE_EDIT_PATH = '/zones/:zoneId'
export const ZONE_VISITS_PATH = '/zones/visits'
export const POI_PATH = '/zones/poi'

export const ZONE_QUERY_KEYS = {
  category: 'category',
  kind: 'kind',
  search: 'q',
  /** `1` includes deactivated zones, which the list hides by default. */
  includeInactive: 'inactive',
  /** Visit report window — `YYYY-MM-DD` day keys in the tenant's zone. */
  from: 'from',
  to: 'to',
  geofenceId: 'zone',
  vehicleId: 'vehicle',
} as const

export function zonePath(zoneId: string): string {
  return `${ZONES_PATH}/${zoneId}`
}

export interface VisitReportParams {
  from?: string
  to?: string
  geofenceId?: string
  vehicleId?: string
}

export function zoneVisitsPath(params: VisitReportParams = {}): string {
  const search = new URLSearchParams()
  if (params.from) search.set(ZONE_QUERY_KEYS.from, params.from)
  if (params.to) search.set(ZONE_QUERY_KEYS.to, params.to)
  if (params.geofenceId) search.set(ZONE_QUERY_KEYS.geofenceId, params.geofenceId)
  if (params.vehicleId) search.set(ZONE_QUERY_KEYS.vehicleId, params.vehicleId)
  const query = search.toString()
  return query.length > 0 ? `${ZONE_VISITS_PATH}?${query}` : ZONE_VISITS_PATH
}
